import View from './views/View'

const route = {
    exact: true,
    purePath: '/about',
    path: '/:lang/about',
    component: View
}

export default route